<pbc-sorter [config]="ReisekostenabrechnungStatiSorterConfig" [sorter]="reisekostenabrechnungStati.sorter$ | async" (sorterChange)="reisekostenabrechnungStati.sorter$.next($event)"></pbc-sorter>
